module.exports = "<app-loading-screen></app-loading-screen>\n<router-outlet></router-outlet>\n"